export const UNINITIALIZED = 'UNINITIALIZED';
export const STARTED = 'STARTED';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';